<template> 
  <div class="category_title_menu"  >
    <van-tabs
      tab-posititon="right"   style="width: 100%;background-color: #eee;"
      v-model:active="active"
      scrollspy
      sticky
      @change="beforeChange"
      color="#3ca7f0"
    >
      <van-tab
        v-for="(item, index) in Categorys"
        :key="index"
        :before-change="CategoryChange"
      >
        <template #title> {{ item.Name }} </template>
        <div class="category_content_itemtitle">
          {{ item.Name }}
        </div>
        <div v-if="item.Description != null && item.Description !='' " style="width: calc(100% - 30px); padding: 5px;margin: 0 auto;display: flex;height: 45px;align-items: center;gap: 15px;">
          <van-icon name="info" size="22" color="red" v-if="item.RequiredDescription"/> 
          <div v-html="item.Description"></div>
        </div>

        <div style="height: 600px" v-if="item.Products.length == 0">
          <van-empty
            :description="tools.GetLanguageValue('public.app.正在加载')"
          />
        </div>

        <div
          class="product_content"
          v-for="(product, indexs) in item.Products"
          :key="indexs"
        >
          <div class="product_item" v-if="product.ProductType == 100"> 
            <StoreProductBroadwise :ProductItem="product" />
          </div>
          <div class="product_item"  v-if="product.ProductType == 500">
            <!-- 固定套餐 -->
            <productFixationCollection :ProductItem="product" />
          </div>
          <div class="product_item" v-if="product.ProductType == 400">
            <!-- 可选套餐 -->
            <ProductChoosableCollection  :ProductItem="product" />
          </div>
        </div>
      </van-tab>
    </van-tabs>
    <p style="text-align: center">Powered by Jiecheng</p>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
 
</template>
<script >
import axios from "../../commons/AxiosMethod.js";
import StoreProductBroadwise from "../../components/tabbars/StoreProductBroadwisePreview.vue";
import ProductFixationCollection from "../../components/tabbars/ProductFixationCollectionPrevie.vue";
import ProductChoosableCollection from "../../components/tabbars/ProductChoosableCollectionPreview.vue";

import StoreTabbar from "../../components/tabbars/StoreShoppingCartTabbar.vue";
import CarouselAdvert from "../../components/CarouselAdvert.vue";
import tools from "../../commons/tools.js";

import { Collapse, CollapseItem, Tab, Tabs } from "vant";
export default {
  data() {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      tools: tools,
      active: "",
      Categorys: [], // 分类列表
      CategoryOpt: {}, // 当前分类
      TableId: "",
      ProductPriceInfo: [],
      ProductImageHeigth:100,
    };
  },
  name: "App",
  mounted() {
    localStorage.setItem("Cache-TableId", this.$route.query.tableId);

    this.TableId = localStorage.getItem("Cache-TableId");

    this.ProductImageHeigth = localStorage.getItem("ProductImageHeigth");
    this.GetCategorys();
     
    
  },
  components: {
    StoreProductBroadwise,
    ProductFixationCollection,
    ProductChoosableCollection,
    StoreTabbar,
    CarouselAdvert,
  },
  methods: {
    // 获取购物车
    GetShoppingCartComplete() {
      axios.apiMethod(
        "/Store/StoreOrder/GetShoppingCart",
        "get",
        {
          TableId: this.TableId,
        },
        (result) => {
          this.Carts = result.Data;

          this.$store.commit({
            type: "updateCart",
            carts: this.Carts,
          });
        },
        (e) => {}
      );
    },
    // 触发切换
    beforeChange(number, name) {
      if (this.Categorys.length < number + 1) {
        return;
      }

      if (number > 2) {
        var categoryj1 = this.Categorys[number - 1];
        this.GetCategoryProduct(categoryj1);
        var categoryj2 = this.Categorys[number - 2];
        this.GetCategoryProduct(categoryj2);
      }

      var category = this.Categorys[number];
      this.GetCategoryProduct(category);
      var category2 = this.Categorys[number + 1];
      this.GetCategoryProduct(category2);
      var category3 = this.Categorys[number + 2];
      this.GetCategoryProduct(category3);
      var category4 = this.Categorys[number + 3];
      this.GetCategoryProduct(category4);
    },
    GetCategoryProduct(category) {

if(category &&  category.Products ){

  if (category.Products.length == 0) {
        axios.apiMethod(
          "/Store/StoreOrder/GetCategoryProduct?categoryId=" + category.Id,
          "get",
          {},
          (result) => {
            category.Products = result.Data;
            this.ProductPriceFormat();
          }
        );
      }


}

    },
    // 获取套餐价格信息
    GetProductPriceInfo() {
      axios.apiMethod(
        "/Store/StoreOrder/GetProductPriceInfo",
        "get",
        {
          tableId: this.TableId,
        },
        (result) => {
          this.ProductPriceInfo = result.Data;
          this.ProductPriceFormat();
        },
        (e) => {}
      );
    },
    // 格式化套餐价格
    ProductPriceFormat() {
      if (this.ProductPriceInfo != null) {
        // 加载之后改变价格
        for (var i = 0; i < this.Categorys.length; i++) {
          this.Categorys[i].Products.forEach((product) => {
            this.ProductPriceInfo.forEach((e) => {
              if (e.Id == product.Id) {
                product.Price = e.Price;
                product.PriceFormat = e.PriceFormat;
                product.Count = e.Count;
                product.PlaceCount = e.PlaceCount;
              }
            });
          });
        }
      }
    },
    // 获取分类
    GetCategorys() {
      var param = {
        
      };
      axios.apiMethod(
        "/Store/StoreOrder/GetAllCategorySimple",
        "post",
        param,
        (result) => {
          this.Categorys = result.Data;
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.category_content_itemtitle { 
  font-size: 12pt;
  font-weight: 700;
  font-size: 14pt;
  padding: 5px 10px;
 
}
.search_content {
  height: 70px;
  display: flex;
  .search {
    width: 100%;
  }
}
.category_title_menu {
  width: 100%;
  background-color: #eee;
  top: 0px;
  z-index: 9090000;
  border-bottom: 1px solid #eee;
}

.product_content {
  width: calc(100% - 20px);
  margin: 0 auto;
 
  background-color: #eee;
  .product_item { 
    margin: 0 auto;
 
  }
}
</style>
